<template>
    <div>
        <div class="mb-3 mb-lg-10" style="text-align: center;">
            <div class="card card-lift shadow border-1 card-instiative1_main">
                <img src="img/strategy/prezident_sh_m.jpg" class="image_instiative1_main">
                <span class="card_span_instiative1_main vertical-center"><strong>{{$t('initsiativ.title')}}</strong><br> <span v-html="$t('initsiativ.respub')"></span></span>
            </div>
        </div>
        <el-row :gutter="15" class="instiative_mobi">
            <div style="flex: 1;"></div>
            <el-col :sm="24" :md="24" :lg="8" class="mb-3 mb-lg-10">
                <div class="card card-lift shadow border-1 card-instiative1">
                    <img src="img/strategy/creativity.svg" class="image_instiative1">
                    <span class="card_span_instiative1 vertical-center"><strong>{{$t('initsiativ.title1')}}</strong> – {{$t('initsiativ.title1_text')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="8" class="mb-3 mb-lg-10">
                <div class="card card-lift shadow border-1 card-instiative1">
                    <img src="img/strategy/football.svg" class="image_instiative1">
                    <span class="card_span_instiative1 vertical-center"><strong>{{$t('initsiativ.title2')}}</strong> – {{$t('initsiativ.title2_text')}}</span>
                </div>
            </el-col>
            <div style="flex: 1;"></div>
        </el-row>
        <el-row :gutter="15">
            <el-col :sm="24" :md="12" :lg="8" class="mb-3 mb-lg-10">
            <div class="card card-lift shadow border-1 card-instiative1">
              <img src="img/strategy/computer.svg" class="image_instiative1">
              <span class="card_span_instiative1 vertical-center"><strong>{{$t('initsiativ.title3')}}</strong> – {{$t('initsiativ.title3_text')}}</span>
            </div>
          </el-col>
            <el-col :sm="24" :md="24" :lg="8" class="mb-3 mb-lg-10">
                <div class="card card-lift shadow border-1 card-instiative1">
                    <img src="img/strategy/book.svg" class="image_instiative1">
                    <span class="card_span_instiative1 vertical-center"><strong>{{$t('initsiativ.title4')}}</strong> – {{$t('initsiativ.title4_text')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" class="mb-3 mb-lg-10">
                <div class="card card-lift shadow border-1 card-instiative1">
                    <img src="img/strategy/tailor.svg" class="image_instiative1">
                    <span class="card_span_instiative1 vertical-center"><strong>{{$t('initsiativ.title5')}}</strong> – {{$t('initsiativ.title5_text')}}</span>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-col :sm="24" :md="24" :lg="24" class="mb-3 mb-lg-10" style="float: right;">
                <div class="card card-lift shadow border-0 card-info_strategy">
                    <strong class="card_info_title">{{$t('initsiativ.info')}}</strong>
                    <div style="overflow: auto; height: 400px; margin-top: 8px;">
                            <span class="card_span_strategy_text">{{$t('initsiativ.info_text')}}
                            </span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "MainPagePanel3"
    }
</script>

<style lang="scss" scoped>
    @import url(../../../assets/css/custom.scss);

    hr {

        border: none;
        border-left: 1px solid #00b0f0;
        height: 14px;
        margin: 4px 5px;
        width: 1px;
    }

    blockquote {
        margin: 0 0 0rem;
    }

    .button_new_m {
        display: block;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: transparent;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: transparent;
    }
</style>